import { AppError, ErrorCode } from "@newxsystems/types";
import { DefaultComponentFactory } from "../factory/default.js";
class ServerContext {
  get factory() {
    return this._factory;
  }
  get pageContext() {
    return this._pageContext;
  }
  constructor({ factory, client }) {
    this._factory = factory || new DefaultComponentFactory();
    this._pageContext = { pathname: "", slug: void 0, staticPage: void 0 };
  }
  dehydrate() {
    return JSON.stringify(this._pageContext);
  }
  hydrate(pageContext) {
    this._pageContext = JSON.parse(pageContext);
  }
  setMode(mode) {
    return this;
  }
  setPageContext(pageContext) {
    this._pageContext = pageContext;
  }
  getPageContext() {
    return this._pageContext;
  }
  setComponentFactory(factory) {
    const newFactory = typeof factory === "function" ? factory(this._factory) : factory;
    if (!newFactory) {
      throw new AppError({
        code: ErrorCode.ENGINE_FACTORY_UNSET,
        message: "Unsetting the context factory is not allowed.",
        hint: "Provide a valid ComponentFactory instance when calling setComponentFactory."
      });
    }
    this._factory = newFactory;
  }
}
export {
  ServerContext
};
//# sourceMappingURL=index.js.map
